import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import { Buttons, Spacer, boxContainer, questionnaireComponents } from "..";

import "./styles.css";

const HighSchoolGrades = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );
  const studentProfile = useSelector(
    (state) => state?.students?.student?.common
  );
  const [curriculumValues, setCurriculumValues] = useState([
    {
      value1: null,
      value2: null,
    },
  ]);

  useEffect(() => {
    setCurriculumValues(
      questionnaire?.curriculumValues?.length > 0
        ? questionnaire?.curriculumValues
        : [
            {
              value1: null,
              value2: null,
            },
          ]
    );
  }, [questionnaire]);

  return (
    <boxContainer.LiteBoxContainer>
      {questionnaire?.curriculum === "British" &&
        curriculumValues?.map((curriculum, index) => (
          <div className={`${index > 0 ? "mt-6" : ""} `} key={index}>
            <div className="section-header flex justify-between items-center">
              Grade {index + 1}
            </div>
            <div className="grid grid-cols-2 gap-x-7 gap-y-6">
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text="Subject"
                  required
                />
                <Spacer height="0.3125em" />
                <questionnaireComponents.QuestionnaireValueBox
                  value={curriculum?.value1}
                />
              </div>
              <div>
                <questionnaireComponents.QuestionnaireLabel
                  text={
                    studentProfile?.student?.grade ===
                      "10 (E.G. O-level First Year)" ||
                    studentProfile?.student?.grade ===
                      "11 (E.G. O-level Second Year)"
                      ? "IGCSE"
                      : "AS & A Level"
                  }
                />
                <Spacer height="0.3125em" />
                <questionnaireComponents.QuestionnaireValueBox
                  value={curriculum?.value2}
                />
              </div>
            </div>
          </div>
        ))}
      {(questionnaire?.curriculum === "American" ||
        questionnaire?.curriculum === "Pakistan FBISE") && (
        <div>
          <questionnaireComponents.QuestionnaireLabel text="GPA" required />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={curriculumValues[0]?.value1}
          />
        </div>
      )}

      {questionnaire?.curriculum === "Other" && (
        <div>
          <questionnaireComponents.QuestionnaireLabel
            text="Please enter your curriculum. We will work on adding it to our application shortly."
            required
          />
          <Spacer height="0.3125em" />
          <questionnaireComponents.QuestionnaireValueBox
            value={curriculumValues[0]?.value1}
          />
        </div>
      )}

      <Spacer height="1.25em" />
      <div className="flex justify-end">
        <div className="w-[12.5em]">
          <Buttons.DefaultButton
            size="large"
            width="full"
            onClick={() => setPage("Test Scores")}
          >
            Next
          </Buttons.DefaultButton>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default HighSchoolGrades;
